var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.airSafetyAndHealthGraphDataLoading)?_c('div',[_c('app-loading')],1):_c('div',[_c('apexchart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }